(function () {
  var BREAKPOINT = 768; // tablet threshold

  var viewport = document.querySelector(".thwma-thslider-viewport.billing");
  var slider   = document.getElementById("thwma-th-list");
  if (!viewport || !slider) return;

  var state = {
    inited: false,
    shell: null,
    prevBtn: null,
    nextBtn: null,
    lastDesktop: window.innerWidth >= BREAKPOINT,
    mql: null,
    // listener refs for clean unbinds
    onPrev: null,
    onNext: null,
    onScroll: null,
    onKey: null
  };

  function getStep() {
    var firstItem = slider.querySelector(".thwma-thslider-item");
    if (!firstItem) return 0;
    var cardWidth = firstItem.getBoundingClientRect().width;
    var cs = window.getComputedStyle(slider);
    var gap = parseFloat(cs.gap || cs.columnGap || 0) || 0;
    return cardWidth + gap;
  }

  function go(delta) {
    var step = getStep();
    if (!step) return;
    var maxScroll = viewport.scrollWidth - viewport.clientWidth;
    var target = Math.max(0, Math.min(maxScroll, viewport.scrollLeft + delta * step));
    viewport.scrollTo({ left: target, behavior: "smooth" });
  }

  function updateDisabled() {
    if (!state.prevBtn || !state.nextBtn) return;
    var atStart = viewport.scrollLeft <= 1;
    var atEnd = viewport.scrollLeft >= (viewport.scrollWidth - viewport.clientWidth - 1);
    state.prevBtn.disabled = atStart;
    state.nextBtn.disabled = atEnd;
  }

  function bind() {
    state.onPrev = function(){ go(-1); };
    state.onNext = function(){ go(1); };
    state.onScroll = function(){ updateDisabled(); };
    state.onKey = function (e) {
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    };

    state.prevBtn.addEventListener("click", state.onPrev);
    state.nextBtn.addEventListener("click", state.onNext);
    viewport.addEventListener("scroll", state.onScroll, { passive: true });
    viewport.addEventListener("keydown", state.onKey);
  }

  function unbind() {
    if (state.prevBtn && state.onPrev) state.prevBtn.removeEventListener("click", state.onPrev);
    if (state.nextBtn && state.onNext) state.nextBtn.removeEventListener("click", state.onNext);
    if (state.onScroll) viewport.removeEventListener("scroll", state.onScroll);
    if (state.onKey) viewport.removeEventListener("keydown", state.onKey);
    state.onPrev = state.onNext = state.onScroll = state.onKey = null;
  }

  function init() {
    if (state.inited) return;

    // Create wrapper shell and move viewport into it
    var shell = document.createElement("div");
    shell.className = "thwma-thslider-shell";
    viewport.parentNode.insertBefore(shell, viewport);
    shell.appendChild(viewport);

    // Ensure scrolling behaviour
    viewport.style.overflowX = "auto";
    viewport.setAttribute("tabindex", "0");

    // Create nav buttons on the shell (fixed, not scrolling)
    var prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.className = "thwma-slider-nav-btn thwma-slider-nav-prev";
    prevBtn.setAttribute("aria-label", "Previous");
    prevBtn.textContent = "‹";

    var nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.className = "thwma-slider-nav-btn thwma-slider-nav-next";
    nextBtn.setAttribute("aria-label", "Next");
    nextBtn.textContent = "›";

    shell.appendChild(prevBtn);
    shell.appendChild(nextBtn);

    state.shell = shell;
    state.prevBtn = prevBtn;
    state.nextBtn = nextBtn;
    state.inited = true;

    bind();
    updateDisabled();
  }

  function destroy() {
    if (!state.inited) return;

    unbind();

    // Move viewport back out of the shell (to where the shell sits)
    if (state.shell && state.shell.parentNode) {
      state.shell.parentNode.insertBefore(viewport, state.shell);
      // remove shell (also removes buttons)
      state.shell.parentNode.removeChild(state.shell);
    }

    viewport.style.overflowX = "";

    state.shell = null;
    state.prevBtn = null;
    state.nextBtn = null;
    state.inited = false;
  }

  // Initial build
  init();

  // Rebuild when the breakpoint flips (mobile <-> desktop)
  state.mql = window.matchMedia("(min-width: " + BREAKPOINT + "px)");
  function onMqlChange(e) {
    var nowDesktop = e.matches;
    if (nowDesktop !== state.lastDesktop) {
      state.lastDesktop = nowDesktop;
      destroy();
      init();
    }
  }
  if (state.mql.addEventListener) {
    state.mql.addEventListener("change", onMqlChange);
  } else if (state.mql.addListener) {
    // older browsers
    state.mql.addListener(onMqlChange);
  }

  // Debounced resize: catches env where matchMedia doesn’t fire or when layout vars change
  var resizeTO;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTO);
    resizeTO = setTimeout(function () {
      var nowDesktop = window.innerWidth >= BREAKPOINT;
      if (nowDesktop !== state.lastDesktop) {
        state.lastDesktop = nowDesktop;
        destroy();
        init();
      } else {
        updateDisabled(); // keep button states fresh
      }
    }, 150);
  });
})();